export default {"src":"/_next/static/media/store.1a951e4b.svg","height":96,"width":96};